import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import PhaseType from 'types/phase';

export const communication = ({ event: { kind, data: { note, new_due_date } },
}) => <div className={kind}>
  {note && <div>{note}</div>}
  {new_due_date && <div>
    Due date updated to {moment(new_due_date).local().format('MM/DD/YYYY h:mm a')}
  </div>}
</div>;

communication.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      new_due_date: PropTypes.string,
      note: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication.jsx